/** Small pieces shared by the tab strip and tab search. */
import type { GroupColor, TabGroup } from "@bundle/core";
import { Avatar, Icon, type Translate } from "@bundle/ui";
import type { TabInfo } from "../tabInfo.ts";

export function TabIcon({ info }: { info: TabInfo }) {
  return (
    <span className="tab-icon">
      {info.emoji !== undefined ? (
        <span className="tab-emoji">{info.emoji}</span>
      ) : info.avatar === undefined ? (
        <Icon name={info.icon} size="icon.sm" />
      ) : (
        <Avatar name={info.avatar.name} square={info.avatar.square} size="avatar.xs" />
      )}
    </span>
  );
}

/** The group's name, or "Unnamed group". */
export function groupLabel(g: TabGroup, t: Translate): string {
  return g.name === "" ? t("shell.group.unnamed") : g.name;
}

/** Colour names (shared with database select options). */
export const COLOR_KEYS: Record<GroupColor, Parameters<Translate>[0]> = {
  blue: "db.color.blue",
  red: "db.color.red",
  yellow: "db.color.yellow",
  green: "db.color.green",
  pink: "db.color.pink",
  purple: "db.color.purple",
  orange: "db.color.orange",
  brown: "db.color.brown",
  gray: "db.color.gray",
};

